import * as util from './util'

export function redirectToTeam (teamInfo) {
  let oldQuery = util.parseUrlSearchToObj()
  let newQuery = {
    ...oldQuery,
    ...teamInfo
  }

  let searchStr = util.genUrlSearchFromObj(newQuery)

  let link = `${window.data_source.sharelink}/team-bag/dist/activity.html?${searchStr}`
  if (util.isCeshi) {
    link = `http://minner.jr.jd.com/flowh5/team-bag/dist/activity.html?${searchStr}`
  }

  if($.device.jdjr){
    let defer = jsBridgeV3.onReady();
    defer.then(function (res) {
      this.jsOpenWeb({
          jumpUrl: link,
          jumpType: 8,
          productId: '',
          isclose: true
      })
    })
  }else{
    window.location.href = link
  }
}

export function redirectToError (msg = '', code = '') {
  let searchStr = util.genUrlSearchFromObj({
    ...util.parseUrlSearchToObj(),
    msg,
    code,
  })
  // if (util.isCeshi) return
  let link = `${window.data_source.sharelink}/team-bag/dist/errorPage.html?${searchStr}`
  if (util.isCeshi) {
    link = `http://minner.jr.jd.com/flowh5/team-bag/dist/errorPage.html?${searchStr}`
  }

  if($.device.jdjr){
    let defer = jsBridgeV3.onReady();
    defer.then(function (res) {
      this.jsOpenWeb({
          jumpUrl: link,
          jumpType: 8,
          productId: '',
          isclose: true
      })
    })
  }else{
    window.location.href = link;
  }
}



// WEBPACK FOOTER //
// ./src/public/redirectTo.js